import { Link } from "react-router-dom";
import { socials } from "../../data/socials";

export const Footer = () => {
    return (
        <div className="border-t border-button w-full flex flex-col items-center justify-end py-6 sm:py-10">
            <p className="text-center">
                Let’s talk code, product ideas, or what it’s like building from
                Kaduna. <br />
                I'm open to freelance, full-time, or collaborations.
            </p>
            <ul className="list-none flex gap-1 mb-3">
                {socials.map((social, index) => (
                    <li key={index}>
                        <Link
                            to={social.link}
                            target="_blank"
                            className="flex p-2 rounded hover:bg-button/50 transition ease-linear"
                            aria-label={social.social}
                        >
                            {social.icon}
                        </Link>
                    </li>
                ))}
            </ul>
            <p>© {new Date().getFullYear()} All rights reserved.</p>
            <p>Designed & Developed by ME</p>
        </div>
    );
};
